export default __webpack_public_path__ + "static/media/wow-pink-16px.85f318c9.svg";